module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9637.32eab80e.jpg";